export const icons = {
  backendValidationIcon: 'error',
  noIcon: '',
  validIcon: 'checkmarkCircle',
};

export default {
  icons,
};
